(function () {
  'use strict';

  const POPUP_SEL = '.avis-popup-atc-content';
  const SWATCH_WRAPPER_SEL = '.avp-productoptionswatchwrapper';
  const SWATCH_SEL = '.avp-productoptionswatch';
  const TRIGGER_CLASS = 'personalised-zoom-trigger';
  const LIGHTBOX_CLASS = 'personalised-zoom-lightbox';

  function getImageUrl(wrapper) {
    const swatch = wrapper.querySelector(SWATCH_SEL);
    if (!swatch) return null;
    const dataSrc = swatch.getAttribute('data-src') || swatch.getAttribute('data_src_hidden');
    if (dataSrc) return dataSrc;
    const bg = (swatch.style.backgroundImage || getComputedStyle(swatch).backgroundImage || '');
    const m = bg.match(/url\(["']?([^"')]+)["']?\)/);
    return m ? m[1] : null;
  }

  function upgradeImageUrl(url) {
    if (!url) return url;
    // Shopify CDN: strip _60x.png / _100x100.png style size markers to get original.
    if (/cdn\.shopify\.com/i.test(url)) {
      return url.replace(/_(\d+)x(\d*)\.(png|jpg|jpeg|webp|gif)/i, '.$3');
    }
    // Avis CDN: filename is <name>_<file-id>x<size>.<ext>.
    // Strip just the x<size> piece to get the full-size original — keep file id.
    if (/avisplus\.io/i.test(url)) {
      return url.replace(/(_\d{6,})x\d+\.(png|jpg|jpeg|webp|gif)/i, '$1.$2');
    }
    return url;
  }

  function buildMagnifierSvg() {
    const NS = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('width', '14');
    svg.setAttribute('height', '14');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const circle = document.createElementNS(NS, 'circle');
    circle.setAttribute('cx', '7');
    circle.setAttribute('cy', '7');
    circle.setAttribute('r', '4.5');
    circle.setAttribute('fill', 'none');
    circle.setAttribute('stroke', 'currentColor');
    circle.setAttribute('stroke-width', '1.6');
    const line = document.createElementNS(NS, 'line');
    line.setAttribute('x1', '10.5');
    line.setAttribute('y1', '10.5');
    line.setAttribute('x2', '14.5');
    line.setAttribute('y2', '14.5');
    line.setAttribute('stroke', 'currentColor');
    line.setAttribute('stroke-width', '1.8');
    line.setAttribute('stroke-linecap', 'round');
    svg.appendChild(circle);
    svg.appendChild(line);
    return svg;
  }

  function ensureTrigger(wrapper) {
    if (wrapper.querySelector('.' + TRIGGER_CLASS)) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = TRIGGER_CLASS;
    btn.setAttribute('aria-label', 'Zoom image');
    btn.appendChild(buildMagnifierSvg());
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const url = upgradeImageUrl(getImageUrl(wrapper));
      if (url) openLightbox(url);
    });
    btn.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    btn.addEventListener('touchstart', function (e) { e.stopPropagation(); }, { passive: true });
    wrapper.appendChild(btn);
  }

  function attachAll() {
    const popup = document.querySelector(POPUP_SEL);
    if (!popup) return;
    const wrappers = popup.querySelectorAll(SWATCH_WRAPPER_SEL);
    for (const w of wrappers) ensureTrigger(w);
  }

  let lightboxEl = null;
  function closeLightbox() {
    if (!lightboxEl) return;
    lightboxEl.remove();
    lightboxEl = null;
    document.removeEventListener('keydown', onKeydown);
    document.documentElement.classList.remove('personalised-zoom-open');
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeLightbox();
  }

  function openLightbox(url) {
    closeLightbox();
    const wrap = document.createElement('div');
    wrap.className = LIGHTBOX_CLASS;
    wrap.tabIndex = -1;

    const img = document.createElement('img');
    img.alt = '';
    img.className = LIGHTBOX_CLASS + '__img';
    img.src = url;

    const close = document.createElement('button');
    close.type = 'button';
    close.className = LIGHTBOX_CLASS + '__close';
    close.setAttribute('aria-label', 'Close');
    close.textContent = '✕';

    wrap.appendChild(img);
    wrap.appendChild(close);

    wrap.addEventListener('click', function (e) {
      if (e.target === wrap) closeLightbox();
    });
    close.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', onKeydown);
    document.documentElement.classList.add('personalised-zoom-open');
    document.body.appendChild(wrap);
    lightboxEl = wrap;
    wrap.focus();
  }

  let scheduled;
  function schedule() {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(attachAll, 80);
  }

  document.addEventListener('click', function (e) {
    const t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.avis-btn-open-popup') || t.closest(POPUP_SEL)) schedule();
  });

  document.addEventListener('change', function (e) {
    const t = e.target;
    if (t && t.closest && t.closest(POPUP_SEL)) schedule();
  });

  setInterval(function () {
    if (document.querySelector(POPUP_SEL)) schedule();
  }, 700);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
